/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */

import { HeapProvider } from "@startree-ui/heap-provider";
import {
    getEnvironmentFromLocation,
    SentryProvider,
} from "@startree-ui/sentry-provider";
import React, { FunctionComponent } from "react";
import { getRemoteManagedUiVersion } from "../../utils/version/version.util";
import { useUser } from "../user-provider/user-provider.component";

const ANALYTICS_APP_ID = atob("MTc3NTk1NTQzNQ==");
const SENTRY_DSN = atob(
    "aHR0cHM6Ly9lOTA3NTdiNzEwZGUxNTEzNjIzNjBhZTQ2NDJiY2MxYkBvNDUwNTQ4NDIwNzMyNTE4NC5pbmdlc3Quc2VudHJ5LmlvLzQ1MDU3NDQ2MjU1NjU2OTY="
);

export const AnalyticsProviderWrapper: FunctionComponent = ({ children }) => {
    const { user } = useUser();

    return (
        <>
            <SentryProvider
                environment={getEnvironmentFromLocation()}
                release={getRemoteManagedUiVersion()}
                sentryDSN={SENTRY_DSN}
                userEmail={user.email}
            />

            <HeapProvider
                appId={ANALYTICS_APP_ID}
                email={user.email}
                name={user.name}
            />

            {children}
        </>
    );
};
